import logo from './logo.svg';
import './App.css';
import React from 'react';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: '0',
      displayFormula: '',
    };
    this.charHandler = this.charHandler.bind(this);
    this.acHandler = this.acHandler.bind(this);
    this.equalHandler = this.equalHandler.bind(this);
  }

  charHandler(event) {
    this.scrollToBottom();
    if (/0/.test(event.target.value)) {
      if (/^\-?0$/.test(this.state.display)) {
        this.setState({
          display: this.state.display
        });
      } else if (/^\D$/.test(this.state.display)) {
          if (/\-$/.test(this.state.display)) {
            if (this.state.displayFormula.length === 0 || /\D$/.test(this.state.displayFormula)) {
              this.setState({
                display: this.state.display + event.target.value,
              });
            } else {
              this.setState(state => ({
                display: event.target.value,
                displayFormula: this.state.displayFormula + state.display
              }));
            }
          } else {
              this.setState(state => ({
                display: event.target.value,
                displayFormula: this.state.displayFormula + state.display
              }));
          }
      } else {
          this.setState({
            display: this.state.display + event.target.value,
          });
      }
    } else if (/[1-9]/.test(event.target.value)) {
        if (/^0$/.test(this.state.display)) {
          this.setState({
            display: event.target.value
          });
        } else if (/^\-0$/.test(this.state.display)) {
            this.setState({
              display: '-' + event.target.value
            });
        } else if (/^\D$/.test(this.state.display)) {
            if (/\-$/.test(this.state.display)) {
              if (this.state.displayFormula.length === 0 || /\D$/.test(this.state.displayFormula)) {
                this.setState({
                  display: this.state.display + event.target.value,
                });
              } else {
                this.setState(state => ({
                  display: event.target.value,
                  displayFormula: this.state.displayFormula + state.display
                }));
              }
            } else {
                this.setState(state => ({
                  display: event.target.value,
                  displayFormula: this.state.displayFormula + state.display
                }));
            }
        } else {
          this.setState({
            display: this.state.display + event.target.value,
          });
        }
    } else if (/\./.test(event.target.value)) {
        if (/\./.test(this.state.display) || /^\D$/.test(this.state.display)) {
          this.setState({
            display: this.state.display
          });
        } else {
          this.setState({
            display: this.state.display + event.target.value
          });
        }
    } else if (/[^\d\.]/.test(event.target.value)) {
          if (/\d$/.test(this.state.display)) {
            if (/^0$/.test(this.state.display) && /\-/.test(event.target.value)) {
              this.setState({
                display: event.target.value
              });
            } else {
                this.setState(state => ({
                  display: event.target.value,
                  displayFormula: this.state.displayFormula + state.display
                }));
            }
          } else if (/[^\d\.]$/.test(this.state.display)) {
              if (/\-/.test(event.target.value)) {
                if (/\d$/.test(this.state.displayFormula)) {
                  this.setState(state => ({
                    display: event.target.value,
                    displayFormula: this.state.displayFormula + state.display
                  }));
                } else {
                    this.setState({
                      display: this.state.display
                    });
                }
              } else {
                  if (/\d$/.test(this.state.displayFormula)) {
                    this.setState({
                      display: event.target.value
                    });
                  } else {
                      if (this.state.displayFormula !== '') {
                        this.setState({
                            displayFormula: this.state.displayFormula.replace(/.$/, ''),
                            display: event.target.value
                        });
                      } else if (/^\-$/.test(this.state.display) && /\+/.test(event.target.value)) {
                          this.setState({
                            display: ''
                          });
                      }
                  }
              }
            } else if (/\.$/.test(this.state.display)) {
                this.setState({
                  display: this.state.display
                });
            }
    }
  }

  acHandler() {
    this.setState({
      displayFormula: '',
      display: '0'
    })
  }

  equalHandler() {
    if (/\d$/.test(this.state.display) && (this.state.displayFormula.substring(this.state.displayFormula.length - 1) + this.state.display) !== '/0') {
      let fullFormula = this.state.displayFormula + this.state.display;
      let result = Number(eval(fullFormula.replace(/-{2}/g, '+')).toFixed(10)).toString();
      this.setState({
        displayFormula: '',
        display: Number(result),
      })
    }
  }

  scrollToBottom() {
    this.disp.scrollIntoView({
                              inline: 'end',
                              behavior: 'smooth'
                          });
  }

  render () {
    return (
      <div className='App'>
          <div id='calculator'>
            <img src={logo} className='App-logo' alt='logo' />
            <div id='fullDisplay'>
              <div id='displayFormula'>{this.state.displayFormula}
                <div id='display' ref={disp => { this.disp = disp; }}>{this.state.display}</div>
              </div>
            </div>
            <div className='buttons'>
              <button value='AC' onClick={this.acHandler} id='clear'>AC</button>
              <button value='/' onClick={this.charHandler} id='divide'>/</button>
              <button value='*' onClick={this.charHandler} id='multiply'>x</button>
              <button value='7' onClick={this.charHandler} id='seven'>7</button>
              <button value='8' onClick={this.charHandler} id='eight'>8</button>
              <button value='9' onClick={this.charHandler} id='nine'>9</button>
              <button value='-' onClick={this.charHandler} id='subtract'>-</button>
              <button value='4' onClick={this.charHandler} id='four'>4</button>
              <button value='5' onClick={this.charHandler} id='five'>5</button>
              <button value='6' onClick={this.charHandler} id='six'>6</button>
              <button value='+' onClick={this.charHandler} id='add'>+</button>            
              <button value='1' onClick={this.charHandler} id='one'>1</button>
              <button value='2' onClick={this.charHandler} id='two'>2</button>
              <button value='3' onClick={this.charHandler} id='three'>3</button>
              <button value='=' onClick={this.equalHandler} id='equals'>=</button>
              <button value='0' onClick={this.charHandler} id='zero'>0</button>
              <button value='.' onClick={this.charHandler} id='decimal'>.</button>
            </div>
          </div>
      </div>
    );
    }
}

export default App;


